<template>
    <div
        v-if="isOpen"
        class="z-50 rounded-md cursor-pointer"
        :class="level?.bgColor"
        @click="close"
    >
        <div class="flex items-center">
            <div class="rounded-l-md px-3 py-2" :class="level?.capColor">
                <Component
                    :is="level?.icon"
                    class="w-5 h-5 text-white"
                ></Component>
            </div>
            <div class="px-3">
                <p
                    data-cy="flash-message"
                    class="text-sm text-black-text font-medium"
                >
                    {{ message }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { flashStore } from '@/store';
import { computed, onUnmounted, watch } from 'vue';
import { BadgeCheckIcon } from '@heroicons/vue/solid';
import { ExclamationIcon } from '@heroicons/vue/solid';
import { ExclamationCircleIcon } from '@heroicons/vue/solid';

const levels = [
    {
        name: 'success',
        capColor: 'bg-success-300',
        bgColor: 'bg-success-100',
        icon: BadgeCheckIcon
    },
    {
        name: 'error',
        capColor: 'bg-error-300',
        bgColor: 'bg-error-100',
        icon: ExclamationIcon
    },
    {
        name: 'warning',
        capColor: 'bg-warning-300',
        bgColor: 'bg-warning-100',
        icon: ExclamationCircleIcon
    }
];

const isOpen = computed(() => {
    return flashStore.isOpen;
});

const level = computed(() => {
    return levels.find((l) => {
        return l.name === flashStore.level;
    });
});

const message = computed(() => {
    return flashStore.message;
});

const close = () => {
    flashStore.doClose();
};

const unwatch = watch(
    () => {
        return flashStore.isOpen;
    },
    () => {
        if (isOpen.value) {
            setTimeout(() => {
                return flashStore.doClose();
            }, 5000);
        }
    }
);

onUnmounted(() => {
    unwatch();
});
</script>
